<template>
  <div id="app">
    <header>
      <b-navbar class="navbarColor" toggleable="md">
        <!--<b-navbar-brand href="/#/">Ideavelop Middleware</b-navbar-brand>-->
        <b-navbar-brand class="navbarBrand" style="background-color: white; border-radius: 15px; margin-left: 15px" href="/#/">
          <img src="./assets/Logo.png" style="padding:5px; max-height: 40px">
        </b-navbar-brand>
        <b-navbar-toggle target="navbar-toggle-collapse"></b-navbar-toggle>

        <b-collapse id="navbar-toggle-collapse" is-nav>
          <b-navbar-nav style="margin-left: 15px;">
            <b-nav-item to="/articles" v-if="$authService.isAuthenticated" style="font-size: large;"><b>Artikelen</b></b-nav-item>
            <b-nav-item to="/logging" v-if="$authService.isAuthenticated" style="font-size: large;"><b>Logboeken</b></b-nav-item>
            <b-nav-item to="/downloadupload" v-if="$authService.isAuthenticated" style="font-size: large;"><b>Import/Export</b></b-nav-item>
            <!--<b-nav-item to="/jobs" v-if="$authService.isAuthenticated" style="font-size: large;"><b>Taken</b></b-nav-item>-->
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item to="/login" v-if="!$authService.isAuthenticated" style="font-size: large;"><b>Inloggen</b></b-nav-item>
            <template v-else>
              <b-nav-item v-on:click="logout" style="font-size: large;"><b>Uitloggen</b></b-nav-item>
            </template>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <main>
      <router-view></router-view>
    </main>
    <footer class="footer">      
      <span class="text-muted small">Versie: {{appVersion}}</span>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
      }
    },
    methods: {
      async logout() {
        await this.$authService.logout()
        this.$router.push({ name: 'login' })
      }
    },
    computed: {
      appVersion() {
        return process.env.VUE_APP_VERSION
      },
    }
  }
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
